var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1903 2350.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2a2a28;}.cls-2{fill:#f8b71f;}.cls-3{fill:#4c4e4d;}.cls-4{fill:#202120;}.cls-5{fill:#ffd02e;}.cls-6{fill:#1c1c1c;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-7,.cls-8{fill:none;stroke:#b3b3ba;stroke-miterlimit:10;stroke-width:2px;}.cls-8{stroke-dasharray:5.98 1.99;}.cls-9{opacity:0.67;}.cls-10{stroke-dasharray:5.94 1.98;}.cls-11{stroke-dasharray:5.91 1.97;}.cls-12{stroke-dasharray:5.93 1.98;}.cls-13{stroke-dasharray:6.01 2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sac") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1482,2620.85s-622.29,7.09-645.95,0S812.39,2609,812.39,2609s-73.35-7.09-85.18-11.83-49.69-16.56-63.88-49.68-30.76-99.38-37.86-198.76c-47.32-68.61-85.18-260.27-89.91-300.49s-9.47-160.9,2.36-205.85,21.3-68.62,21.3-68.62-7.1-33.13-2.37-42.59,42.59-16.56,45-16.56,35.49-11.83,35.49-21.3,59.15-470.85,85.18-548.94S846.72,820.26,930.7,780c-18.93-63.88-54.42-234.24-35.49-291,2.36-9.46,14.19-9.46,33.12-9.46S1124.72,444,1124.72,444s30.76-4.73,37.86-9.47,34.17-15.56,52.05,9.47L1314,642.78l168-2.37Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1482,1526.06l-558.4-.72s-7.7-117.26,47.32-158.53c28.39-21.3,71-26,118.31-26H1482Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "367.07 2215.26 393.1 1252.25 951.5 1252.25 951.5 2215.26 367.07 2215.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M800.56,2488.34s59.15-998.49,75.72-1055.28S952,1317.12,985.12,1312.39s229.51-28.39,307.59-33.13,189.8-13.56,189.8-13.56l-.87,29.45s-453.93,24.34-491.79,43.27-78.08,73.34-80.45,94.64-66.25,1055.28-66.25,1055.28Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M679.89,2549.86s35.49-239,47.32-395.14,75.72-835.23,63.89-925.15H772.17s-123,1003.21-123,1116.81C649.13,2424.46,679.89,2549.86,679.89,2549.86Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1044.27,957.47h177.46s-16.56-265,0-328.89,40.22-213,37.86-234.24a44.14,44.14,0,0,1-9.47-7.1s59.15-56.79,231.88-49.69V273.67s-115.94-7.1-217.68,28.39c-16.56,7.1-42.59,4.73-52.06,14.2s-16.56,33.12-45,73.35c-35.49,59.15-75.72,85.18-97,134.87S1041.9,860.46,1044.27,957.47Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 774.04,
    y: 1309.04,
    width: 177.46,
    height: 118.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 388.37,
    y: 1495.96,
    width: 563.13,
    height: 54.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M992.22,1771.41s-2.37-7.1-14.2-7.1-18.93,16.57-18.93,16.57H942.53s0,7.1-7.1,14.19,0,118.31,0,118.31-2.37,33.12,26,33.12,30.76-28.39,30.76-28.39-9.47-73.35-9.47-89.91c4.73-2.37,9.47-14.2,9.47-14.2H1023v-42.59ZM961.46,1937a18.93,18.93,0,1,1,18.93-18.93A18.92,18.92,0,0,1,961.46,1937Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1467.8,1253.24l-18.93-7.1s-42.59,2.36-44.95,7.1-16.56,14.19-11.83,21.29l4.73,4.73s-9.46,42.59-7.1,52.06,7.1,21.29,23.66,21.29,30.76-7.1,33.13-16.56-4.73-47.32-4.73-47.32h21.29s7.1-2.37,9.47-7.1S1467.8,1253.24,1467.8,1253.24Zm-50.87,89.91c-11.11,0-20.11-5.3-20.11-11.83s9-11.83,20.11-11.83,20.11,5.29,20.11,11.83S1428,1343.15,1416.93,1343.15Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1437,619.12l-35.49-4.73-28.39,33.12h7s-26,37.86-28.34,42.59-2.36,14.2,0,16.57,52.06-9.47,56.79-11.84,6.68-47.32,6.68-47.32h52.47v-9.46Zm-28.39,18.93,16.56-9.47,26,7.1,4.73,2.37Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 305.55,
    y1: 691.48,
    x2: 308.55,
    y2: 691.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 310.55,
    y1: 691.48,
    x2: 947.5,
    y2: 691.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 948.5,
    y1: 691.48,
    x2: 951.5,
    y2: 691.48
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 520.87,
    y1: 672.55,
    x2: 523.87,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 525.85,
    y1: 672.55,
    x2: 675.41,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 676.4,
    y1: 672.55,
    x2: 679.4,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 520.87,
    y1: 554.25,
    x2: 523.87,
    y2: 554.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 525.85,
    y1: 554.25,
    x2: 675.41,
    y2: 554.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 676.4,
    y1: 554.25,
    x2: 679.4,
    y2: 554.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 520.87,
    y1: 554.25,
    x2: 520.87,
    y2: 557.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 520.87,
    y1: 559.22,
    x2: 520.87,
    y2: 668.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 520.87,
    y1: 669.55,
    x2: 520.87,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 679.4,
    y1: 554.25,
    x2: 679.4,
    y2: 557.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 679.4,
    y1: 559.22,
    x2: 679.4,
    y2: 668.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 679.4,
    y1: 669.55,
    x2: 679.4,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 520.87,
    y1: 554.25,
    x2: 523.27,
    y2: 556.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 524.86,
    y1: 557.23,
    x2: 676.2,
    y2: 670.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 676.99,
    y1: 670.76,
    x2: 679.4,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 679.4,
    y1: 554.25,
    x2: 676.99,
    y2: 556.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 675.41,
    y1: 557.23,
    x2: 524.07,
    y2: 670.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 523.27,
    y1: 670.76,
    x2: 520.87,
    y2: 672.55
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 305.55,
    y1: 719.88,
    x2: 308.55,
    y2: 719.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 310.55,
    y1: 719.88,
    x2: 947.5,
    y2: 719.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 948.5,
    y1: 719.88,
    x2: 951.5,
    y2: 719.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M715.38,2486a7.18,7.18,0,0,0,2.09,2.12",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M719.17,2489.15c46.62,25.44,465.43,29.44,758.82,22.94",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1479,2512.07l3-.07",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1482,2620.85s622.29,7.09,645.95,0,23.66-11.84,23.66-11.84,73.35-7.09,85.18-11.83,49.69-16.56,63.88-49.68,30.76-99.38,37.86-198.76c47.32-68.61,85.18-260.27,89.91-300.49s9.47-160.9-2.36-205.85-21.3-68.62-21.3-68.62,7.1-33.13,2.37-42.59-42.59-16.56-45-16.56-35.49-11.83-35.49-21.3-59.15-470.85-85.18-548.94S2117.28,820.26,2033.3,780c18.93-63.88,54.42-234.24,35.49-291-2.36-9.46-14.19-9.46-33.12-9.46S1839.28,444,1839.28,444s-30.76-4.73-37.86-9.47S1767.25,419,1749.37,444L1650,642.78l-168-2.37Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1482,1526.06l558.4-.72s7.7-117.26-47.32-158.53c-28.39-21.3-71-26-118.31-26H1482Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1535.93 2215.26 1509.9 1252.25 951.5 1252.25 951.5 2215.26 1535.93 2215.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2163.44,2488.34s-59.15-998.49-75.72-1055.28-75.71-115.94-108.84-120.67-229.51-28.39-307.59-33.13-189.8-13.56-189.8-13.56l.87,29.45s453.93,24.34,491.79,43.27,78.08,73.34,80.45,94.64,66.25,1055.28,66.25,1055.28Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2284.11,2549.86s-35.49-239-47.32-395.14-75.72-835.23-63.89-925.15h18.93s123,1003.21,123,1116.81C2314.87,2424.46,2284.11,2549.86,2284.11,2549.86Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1919.73,957.47H1742.27s16.56-265,0-328.89-40.22-213-37.86-234.24a44.14,44.14,0,0,0,9.47-7.1s-59.15-56.79-231.88-49.69V273.67s115.94-7.1,217.68,28.39c16.56,7.1,42.59,4.73,52.06,14.2s16.56,33.12,45,73.35c35.49,59.15,75.72,85.18,97,134.87S1922.1,860.46,1919.73,957.47Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1482,
    y: 1582.12,
    width: 177.46,
    height: 118.31,
    transform: "translate(2610.96 3009.47) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1482,
    y: 1769.05,
    width: 563.13,
    height: 54.42,
    transform: "translate(2996.63 3319.43) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1941,1771.41V1814h30.76s4.74,11.83,9.47,14.2c0,16.56-9.47,89.91-9.47,89.91s2.37,28.39,30.76,28.39,26-33.12,26-33.12,7.1-111.21,0-118.31-7.1-14.19-7.1-14.19h-16.56s-7.1-16.57-18.93-16.57-14.2,7.1-14.2,7.1Zm42.59,146.7a18.93,18.93,0,1,1,18.93,18.93A18.94,18.94,0,0,1,1983.61,1918.11Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1491.46,1281.63c2.37,4.73,9.47,7.1,9.47,7.1h21.29s-7.09,37.86-4.73,47.32,16.56,16.56,33.13,16.56,21.29-11.83,23.66-21.29-7.1-52.06-7.1-52.06l4.73-4.73c4.73-7.1-9.46-16.56-11.83-21.29s-44.95-7.1-44.95-7.1l-18.93,7.1S1489.1,1276.9,1491.46,1281.63Zm35.5,49.69c0-6.54,9-11.83,20.11-11.83s20.11,5.29,20.11,11.83-9,11.83-20.11,11.83S1527,1337.85,1527,1331.32Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1496.2,638.05v9.46h52.47s1.95,45,6.68,47.32,54.42,14.2,56.79,11.84,2.36-11.84,0-16.57-28.34-42.59-28.34-42.59h7l-28.39-33.12L1527,619.12Zm11.83,0,4.73-2.37,26-7.1,16.56,9.47Z",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1597.45,
    y1: 691.48,
    x2: 1594.45,
    y2: 691.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1592.45,
    y1: 691.48,
    x2: 955.5,
    y2: 691.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 954.5,
    y1: 691.48,
    x2: 951.5,
    y2: 691.48
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1382.13,
    y1: 672.55,
    x2: 1379.13,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1377.15,
    y1: 672.55,
    x2: 1227.59,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1226.6,
    y1: 672.55,
    x2: 1223.6,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1382.13,
    y1: 554.25,
    x2: 1379.13,
    y2: 554.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1377.15,
    y1: 554.25,
    x2: 1227.59,
    y2: 554.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1226.6,
    y1: 554.25,
    x2: 1223.6,
    y2: 554.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1382.13,
    y1: 554.25,
    x2: 1382.13,
    y2: 557.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1382.13,
    y1: 559.22,
    x2: 1382.13,
    y2: 668.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1382.13,
    y1: 669.55,
    x2: 1382.13,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1223.6,
    y1: 554.25,
    x2: 1223.6,
    y2: 557.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1223.6,
    y1: 559.22,
    x2: 1223.6,
    y2: 668.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1223.6,
    y1: 669.55,
    x2: 1223.6,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1382.13,
    y1: 554.25,
    x2: 1379.73,
    y2: 556.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1378.14,
    y1: 557.23,
    x2: 1226.8,
    y2: 670.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1226.01,
    y1: 670.76,
    x2: 1223.6,
    y2: 672.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1223.6,
    y1: 554.25,
    x2: 1226.01,
    y2: 556.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1227.59,
    y1: 557.23,
    x2: 1378.94,
    y2: 670.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1379.73,
    y1: 670.76,
    x2: 1382.13,
    y2: 672.55
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1597.45,
    y1: 719.88,
    x2: 1594.45,
    y2: 719.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1592.45,
    y1: 719.88,
    x2: 955.5,
    y2: 719.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 954.5,
    y1: 719.88,
    x2: 951.5,
    y2: 719.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2248.62,2486a7.18,7.18,0,0,1-2.09,2.12",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2244.83,2489.15c-46.62,25.44-465.43,29.44-758.82,22.94",
    transform: "translate(-530.5 -273.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1485,2512.07l-3-.07",
    transform: "translate(-530.5 -273.09)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSac);
export default __webpack_public_path__ + "static/media/sac.949c1e7f378006ae95eb5f1374a52c42.svg";
export { ForwardRef as ReactComponent };